import { render, staticRenderFns } from "./TopicTeaser.vue?vue&type=template&id=8abc8e82&"
import script from "./TopicTeaser.vue?vue&type=script&lang=js&"
export * from "./TopicTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports